import React from "react";
import PropTypes from "prop-types";
import '../css/youtube_embed_view.css';

const YoutubeEmbedView = ({ embedId }) => (
	<div className="video-responsive"
		style={{ }}>
		<iframe
			width="853"
			height="480"
			src={`https://www.youtube.com/embed/${embedId}`}
			frameBorder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			allowFullScreen
			title="Embedded youtube"
		/>
	</div>
);

YoutubeEmbedView.propTypes = {
	embedId: PropTypes.string.isRequired
};

export default YoutubeEmbedView;